import Academie from './Academie';

export default Academie;
